import React, { useEffect, useRef } from 'react';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import ReviewCard from './review/ReviewCard';
import ReviewPanel from './review/ReviewPanel';
import { closePanel } from './review/reviewStore';
import { addFile, legalReset, removeFile, useLegalEntries } from './legalCheckStore';

// The upload box Legal accounts get instead of the plain one, on create ticket
// and on comments. Files reach the parent exactly as before (onChangeStatus), so
// what gets submitted is unchanged; each Word or PDF file is also checked the
// moment it is picked. Its result shows under the box (ReviewCard), and opens
// in the side panel (ReviewPanel) to be reviewed Pasal by Pasal.

const ACCENT = '#0096D2';

function LegalUploadBox({ source, onChangeStatus, refresh, styles = {} }) {
  const list = useLegalEntries(source);

  useEffect(() => () => { closePanel(); legalReset(source); }, [source]);

  // The parent resets its dropzone by changing `refresh` (after a submit or a
  // draft save); the files are gone, so their results go too.
  const firstRefresh = useRef(true);
  useEffect(() => {
    if (firstRefresh.current) { firstRefresh.current = false; return; }
    legalReset(source);
  }, [refresh, source]);

  const handleChangeStatus = ({ meta, file }, status) => {
    onChangeStatus(meta, file, status);
    if (status === 'done') addFile(source, file);
    else if (status === 'removed') removeFile(source, file);
  };

  const dzStyles = {
    ...styles,
    dropzone: { ...(styles.dropzone || {}), borderColor: ACCENT, background: '#f5fbfe' },
    inputLabel: { ...(styles.inputLabel || {}), color: ACCENT },
  };

  return (
    <div>
      <Dropzone
        key={refresh}
        onChangeStatus={handleChangeStatus}
        accept="*"
        styles={dzStyles}
        inputContent="Drop your file here. Word (.docx) and PDF files are checked as you drop them"
      />
      {list.map((e) => <ReviewCard key={e.uid} source={source} entry={e} />)}
      <ReviewPanel source={source} entries={list} />
    </div>
  );
}

export default LegalUploadBox;
